const createCaptchaImage = (text) => {
  const canvas = document.createElement('canvas')
  canvas.width = 200
  canvas.height = 80
  const ctx = canvas.getContext('2d')
  ctx.fillStyle = getRandomColor()
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  for (let i = 0; i < 100; i++) {
    ctx.fillStyle = getRandomColor()
    ctx.beginPath()
    ctx.arc(
      Math.random() * canvas.width, Math.random() * canvas.height, Math.random() * 3,
      0,
      Math.PI * 2
    )
    ctx.fill()
  }

  for (let i = 0; i < 5; i++) {
    ctx.strokeStyle = getRandomColor()
    ctx.lineWidth = Math.random() * 3
    ctx.beginPath()
    ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height)
    ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height)
    ctx.stroke()
  }

  ctx.font = 'bold 40px Arial'
  ctx.fillStyle = getRandomColor()
  ctx.textBaseline = 'middle'
  ctx.textAlign = 'center'

  text.split('').forEach((char, index) => {
    const x = 30 + index * 30 + Math.random() * 10
    const y = canvas.height / 2 + (Math.random() * 20 - 10)
    const angle = (Math.random() - 0.5) * Math.PI / 4

    ctx.save()
    ctx.translate(x, y)
    ctx.rotate(angle)
    ctx.fillText(char, 0, 0)
    ctx.restore()
  })

  return canvas.toDataURL('image/png')
}

const getRandomColor = () => {
  const letters = '0123456789ABCDEF'
  return `#${Array.from({ length: 6 }, () => letters[Math.floor(Math.random() * 16)]).join('')}`
}

export { createCaptchaImage }